import React from 'react';
import LeadsBoard from '../../components/dashboard/LeadsBoard';
import GrowthBoard from '../../components/dashboard/GrowthBoard';
import AccountsTable from '../../components/dashboard/AccountsBoard';
import IntentLeadsBoard from '../../components/dashboard/IntentLeadsBoard';

const DashboardWidgets = () => (
  <>
    <LeadsBoard />
    <GrowthBoard />
    <AccountsTable />
    <IntentLeadsBoard />
  </>
);

export default DashboardWidgets;
